import { theme, useResponsive } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";

import { useNewsletterListContext } from "scmp-app/components/newsletter/newsletter-list/newsletter-category-item-list/contexts";

import { myNewsNewsletterId, myNewsNewsletterUrl } from "./consts";
import {
  Container,
  Description,
  EyeIcon,
  Frequency,
  HeaderWrapper,
  SetupBox,
  SetupBoxButton,
  SetupBoxButtonText,
  SetupBoxText,
  Title,
  Wrapper,
} from "./styles";

export const NewsletterMyNewsWidget: FunctionComponent = () => {
  const isMobile = useResponsive(theme.breakpoints.only("mobile"));
  const { activeNewsletterId, setActiveNewsletterId, setIsDisplayMobilePreview } =
    useNewsletterListContext();

  const isFocused = activeNewsletterId === myNewsNewsletterId;

  const handleMobilePreview = () => {
    if (!isMobile) return;
    setIsDisplayMobilePreview(previous => !previous);
  };

  return (
    <Container $isFocused={isFocused}>
      <Wrapper $isFocused={isFocused} onClick={() => setActiveNewsletterId(myNewsNewsletterId)}>
        <HeaderWrapper>
          <Frequency>daily</Frequency>
          <EyeIcon onClick={handleMobilePreview} />
          <Title>myNEWS</Title>
        </HeaderWrapper>
        {isFocused && (
          <>
            <Description>
              Curated news that matters to you with five must-read articles sent to you each day,
              plus a round-up of recommended stories from your favourite topics.
            </Description>
            <SetupBox>
              <SetupBoxText>
                Set-up myNews now and enjoy five curated articles sent directly to your inbox each
                day.
              </SetupBoxText>
              <SetupBoxButton onClick={() => (window.location.href = myNewsNewsletterUrl)}>
                <SetupBoxButtonText>SET UP NOW</SetupBoxButtonText>
              </SetupBoxButton>
            </SetupBox>
          </>
        )}
      </Wrapper>
    </Container>
  );
};

NewsletterMyNewsWidget.displayName = "NewsletterMyNewsWidget";
